import { makeCloudFunction } from "../makeCloudFunction";
import { Store } from "@functions-types";
import { makeUseCloudFunction } from "../makeUseCloudFunction";

export type { Store };
export const listStores = makeCloudFunction<void, Store[]>("store", "listStores");
export const useListStores = makeUseCloudFunction(listStores);
